export const STORE_USER = "STORE_USER";
export const STORE_ALL_CONTACTS = "STORE_ALL_CONTACTS";
export const UPDATE_EMPLOYEES = "UPDATE_EMPLOYEES";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const INIT_REQUEST = "INIT_REQUEST";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PROFILE_IMAGE = "UPDATE_PROFILE_IMAGE";
export const RESET_RESPONSE = "RESET_RESPONSE";
export const OPEN_DIALOG = "OPEN_DIALOG";
export const SHOW_PROGRESS_DIALOG = "SHOW_PROGRESS_DIALOG";
export const HIDE_PROGRESS_DIALOG = "HIDE_PROGRESS_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";
export const UNAUTHORIZED = "UNAUTHORIZED";
export const STORE_NOMINEE = "STORE_NOMINEE";
export const REMOVE_NOMINEE = "REMOVE_NOMINEE";
export const CLEAR_NOMINEE = "CLEAR_NOMINEE";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";
export const CLEAR_DATA = "CLEAR_DATA";

// Drawer Actions
export const UPDATE_DRAWER_MENU = "UPDATE_DRAWER_MENU";
